import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import type { JobType } from './jobsTasks'
import { tasksMap } from './jobsTasks'

const storageKey = 'storage-timer-'

// To fix undefined getLogger
const logger = () => getLogger('JobScheduler')?.value

export interface JobSchedule {
    jobType: JobType
    scheduleInSeconds: number
    firedEventIds: string[] // Unique event ids that have been fired and won't be fired again (such as notifications)
    task: () => void
}

interface ScheduledJobItem extends Omit<JobSchedule, 'task' | 'scheduleInSeconds'> {
    scheduleInMs: number
}

export const scheduleJob = ({ jobType, scheduleInSeconds = 0 }: Omit<JobSchedule, 'task' | 'firedEventIds'>) => {
    const nowInMs = new Date().getTime()
    const scheduleInMs = nowInMs + scheduleInSeconds * 1000
    setJobItem({ jobType, scheduleInMs, firedEventIds: [] })
    enqueJob(jobType)
}

// This will run a job event (custom function) if its job is scheduled and if the event wasn't triggered before
export const runJobEvent = (jobType: JobType, eventId: string, event: () => void) => {
    const scheduledJob = getScheduledJob(jobType)
    if (!scheduledJob) return
    if (scheduledJob.firedEventIds.includes(eventId)) return
    event()
    setJobItem({ jobType, firedEventIds: [...scheduledJob.firedEventIds, eventId] })
}

export const initScheduledJobsRunner = () => {
    Object.keys(tasksMap).forEach((job: JobType) => enqueJob(job))
}
// Init a checker for scheduled jobs, and run them, or remove expired jobs
const enqueJob = (job: JobType): void => {
    const jobSchedule = getScheduledJob(job) // Fetched continually in case storage timer is cleared externally.
    logger().info(`checking job ${job}`)
    if (!jobSchedule) {
        logger().info(`no schedule for job ${job}`)
        return
    }

    const timer = setInterval(() => {
        // run task on schedule
        if (new Date().getTime() >= jobSchedule.scheduleInMs) {
            logger().info(`jobs with id found ${job}`)
            const task = tasksMap[job]!
            task()
            removeScheduledJob(job)
            clearInterval(timer)
            logger().info(`removing ${job} from schedule`)
        }
    }, 1000)
}

// gets a schedule in MS
const getScheduledJob = (jobType?: JobType) => {
    if (!jobType) return
    const jobItemStr = localStorage.getItem(`${storageKey}${jobType}`)
    const jobItem = (jobItemStr ? JSON.parse(jobItemStr) : null) as ScheduledJobItem
    if (!jobItem) return
    return jobItem
}

// remove a jobs from a queue
const removeScheduledJob = (jobType: JobType) => {
    const key = `${storageKey}${jobType}`
    localStorage.removeItem(key)
}

// add or update job in a storage
const setJobItem = (job: Partial<ScheduledJobItem>) => {
    const scheduledJob = getScheduledJob(job?.jobType)
    localStorage.setItem(`${storageKey}${job.jobType}`, JSON.stringify({ ...scheduledJob, ...job }))
}
